import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import JsonView from '@uiw/react-json-view';
import { toast } from 'sonner';
import { apiFetch } from '../lib/api';

export default function UserPage() {
  const params = useParams();
  const [search] = useSearchParams();
  const [username, setUsername] = useState(
    () => params.id || search.get('q') || '',
  );
  const [data, setData] = useState<Record<string, unknown> | null>(null);

  useEffect(() => {
    if (params.id) setUsername(params.id);
  }, [params.id]);

  async function load(u: string) {
    if (!u.trim()) return;
    try {
      const res = await apiFetch(`/user/${encodeURIComponent(u.trim())}`);
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setData(json as Record<string, unknown>);
    } catch (e) {
      toast.error('User not found or request failed.');
      setData(null);
    }
  }

  useEffect(() => {
    const q = params.id || search.get('q');
    if (q) load(q);
  }, [params.id, search]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-ink">User lookup</h1>
        <p className="text-sm text-ink-muted">
          <code className="rounded bg-slate-100 px-1 text-xs">GET /user/:username</code>
        </p>
      </div>
      <form
        className="flex max-w-xl flex-wrap gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          void load(username);
        }}
      >
        <input
          className="min-w-[200px] flex-1 rounded-lg border border-slate-200 px-3 py-2 text-sm"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username or email"
        />
        <button
          type="submit"
          className="rounded-lg bg-brand px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
        >
          Load
        </button>
      </form>
      {data && (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white p-4 text-sm">
          <JsonView value={data} style={{ '--w-rjv-background-color': '#ffffff' } as React.CSSProperties} />
        </div>
      )}
    </div>
  );
}
